import { useEffect } from 'react';

const SITE_URL = 'https://www.casdave.co.in';
const DEFAULT_IMAGE = '/images/logo_dna.webp';

const SEO = ({ title, description, keywords, canonicalPath, ogImage = DEFAULT_IMAGE, ogType = 'website', robots = 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1', schemaMarkup }) => {
  const pageTitle = title || 'Dave & Associates | Chartered Accountants in Ahmedabad';
  const pageDescription = description || 'Dave & Associates is a Chartered Accountancy firm in Ahmedabad offering taxation, GST, audit, accounting, project finance, virtual CFO and advisory services.';
  const pathname = canonicalPath || window.location.pathname;
  const canonicalUrl = SITE_URL + (pathname === '/' ? '/' : pathname.replace(/\/$/, ''));
  const imageUrl = ogImage.startsWith('http') ? ogImage : SITE_URL + ogImage;

  useEffect(() => {
    const setMeta = (selector, value) => {
      let element = document.head.querySelector(selector);
      if (!element) {
        element = document.createElement('meta');
        const match = selector.match(/meta\[(name|property)="([^"]+)"\]/);
        if (match) element.setAttribute(match[1], match[2]);
        document.head.appendChild(element);
      }
      element.setAttribute('content', value);
    };
    const setLink = (rel, href) => {
      let element = document.head.querySelector('link[rel="' + rel + '"]');
      if (!element) {
        element = document.createElement('link');
        element.rel = rel;
        document.head.appendChild(element);
      }
      element.href = href;
    };

    document.title = pageTitle;
    setMeta('meta[name="description"]', pageDescription);
    setMeta('meta[name="robots"]', robots);
    if (keywords) setMeta('meta[name="keywords"]', keywords);
    setLink('canonical', canonicalUrl);
    setMeta('meta[property="og:title"]', pageTitle);
    setMeta('meta[property="og:description"]', pageDescription);
    setMeta('meta[property="og:url"]', canonicalUrl);
    setMeta('meta[property="og:type"]', ogType);
    setMeta('meta[property="og:image"]', imageUrl);
    setMeta('meta[property="og:image:alt"]', pageTitle + ' - Dave & Associates');
    setMeta('meta[name="twitter:card"]', 'summary_large_image');
    setMeta('meta[name="twitter:title"]', pageTitle);
    setMeta('meta[name="twitter:description"]', pageDescription);
    setMeta('meta[name="twitter:image"]', imageUrl);

    let script = document.getElementById('page-structured-data');
    if (schemaMarkup) {
      if (!script) {
        script = document.createElement('script');
        script.id = 'page-structured-data';
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schemaMarkup);
    } else if (script) script.remove();

    return () => document.getElementById('page-structured-data')?.remove();
  }, [pageTitle, pageDescription, keywords, canonicalUrl, imageUrl, ogType, robots, schemaMarkup]);

  return null;
};

export default SEO;
